import script from "./gamesearchPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./gamesearchPopup.vue?vue&type=script&lang=ts&setup=true"

import "./gamesearchPopup.vue?vue&type=style&index=0&id=4632fbbd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4632fbbd"]])

export default __exports__